import { render, staticRenderFns } from "./backend-deptment.vue?vue&type=template&id=3ec03476&"
import script from "./backend-deptment.vue?vue&type=script&lang=js&"
export * from "./backend-deptment.vue?vue&type=script&lang=js&"
import style0 from "./backend-deptment.vue?vue&type=style&index=0&id=3ec03476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports